"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _difference = _interopRequireDefault(require("./difference.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Return a version of the array that does not contain the specified value(s).
var _default = exports.default = (0, _restArguments.default)(function (array, otherArrays) {
  return (0, _difference.default)(array, otherArrays);
});